import styled from 'styled-components';
import colors from '../../../style/colors';
import { darken } from '../../../style';
import UiLink, { UiLinkProps } from '../ui-link';
import { decorations, variants } from '../style';

const BlackLinkComponent = styled(UiLink)<UiLinkProps>`
  ${props => variants[props.variant || 'gray900']};
  font-weight: ${props => props.weight || 500};
  cursor: pointer;
  ${props => props.decoration && decorations[props.decoration]};

  &:visited:not(.disabled):not([disabled]) {
    ${props => variants[props.variant || 'gray900']};
    text-decoration: ${props => props.decoration};
  }

  &:focus:not(.disabled):not([disabled]) {
    color: ${props => props.theme.actionColor};
  }

  &:hover:not(.disabled):not([disabled]) {
    color: ${props => props.theme.actionColor};
  }

  &:active:not(.disabled):not([disabled]),
  &.active:not(.disabled):not([disabled]) {
    color: ${props => darken(0.08, props.theme.actionColor)};
  }

  &.disabled,
  &[disabled] {
    color: ${colors.gray600};
    text-decoration: none;
  }

  &[role='button'] {
    background: transparent;
    border: 1px solid transparent;

    &:focus-visible:not(.disabled):not([disabled]) {
      border: 1px solid ${props => props.theme.actionColor};
    }
  }
`;

const BlackLink = ({ ...rest }: UiLinkProps) => {
  return <BlackLinkComponent decoration={'underline'} {...rest} />;
};

BlackLink.displayName = 'BlackLink';

export default BlackLink;
